import styled from 'styled-components'

export const LeftArrow = styled.img.attrs(props => ({
	src: '/gwmbrasil/assets/seta-esquerda.svg'
}))`
	position: absolute;
	width: 32px;
	height: 32px;
	left: 5%;
	top: 80px;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	outline: none;
	z-index: 1;
	display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
`

export const RightArrow = styled.img.attrs(props => ({
	src: '/gwmbrasil/assets/seta-direita.svg'
}))`
	position: absolute;
	width: 32px;
	height: 32px;
	right: 5%;
	top: 80px;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	outline: none;
	z-index: 1;
	display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
`
